<template>
  <section>
    <h3 class="mb-0">
      {{ $t('basketModal.relatedAccessories') }}
    </h3>
    <ul class="unstyled-list">
      <li
        v-for="accessoryProduct in accessoryProducts"
        :key="accessoryProduct.id"
        :class="$style.accessoryItem"
      >
        <BaseImage
          v-show="accessoryProduct.matchedFirstImageUrl || fallbackImage"
          :class="$style.image"
          :src="
            accessoryProduct.matchedFirstImageUrl
              ? accessoryProduct.matchedFirstImageUrl
              : fallbackImage
          "
          :fallback-image="fallbackImage"
          :width="accessoryProduct.matchedFirstImageSize"
        />
        <h3 class="ma-0" :class="$style.title">{{ accessoryProduct.name }}</h3>
        <p class="mb-0" :class="$style.code">
          {{ $t('product.ordernumber', { code: accessoryProduct.code }) }}
        </p>
        <BrandPrices
          v-show="!(accessoryProduct.isArchiveProductScope || accessoryProduct.isArchiveScope)"
          :group-prices="accessoryProduct.groupPrices"
          :show-brand="false"
          :class="$style.brandPrice"
        />

        <div class="mt-4 flex-grow-1" :class="$style.amount">
          <QuantityButtons
            :value="amounts[accessoryProduct.id] || 0"
            class="ml-n2"
            type="number"
            :min="0"
            color="primary"
            :disabled="loading"
            :label="$tc('basketModal.amountLabel', 0)"
            @input="$emit('input', { id: accessoryProduct.id, amount: $event })"
          />
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import FallbackImage from '@/images/placeholder.png'
import BrandPrices from '@/js/components/ProductDetail/BrandPrices.vue'
import QuantityButtons from '@/js/components/Shared/QuantityButtons.vue'

export default {
  name: 'ProducBasketFormAccessories',
  components: {
    BrandPrices,
    QuantityButtons,
  },
  props: {
    accessoryProducts: {
      type: Array,
      default: () => [],
    },
    amounts: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fallbackImage: FallbackImage,
    }
  },
  computed: {},
  // mounted() {
  //   this.amounts = this.accessoryProducts.reduce((acc, p) => {
  //     acc[p.id] = 0
  //     return acc
  //   }, {})
  // },
  methods: {
    // amountChange(code, amount) {
    //   console.log(
    //     '🚀 ~ file: ProducBasketFormAccessories.vue:86 ~ amountChange ~ code, amount:',
    //     code,
    //     amount,
    //   )
    //   this.amounts[code] = amount
    // },
  },
}
</script>

<style lang="scss" module>
.accessoryItem {
  display: grid;

  grid-row-gap: 0.35rem;
  grid-column-gap: 1rem;
  grid-template-areas:
    'image title title'
    'image code price'
    'image amount amount';

  grid-template-rows: auto;
  grid-template-columns: minmax(11rem, 1fr) 1fr 1fr;
  padding-top: 0.75rem;

  border-bottom: var(--border-grey-lighten-1);
}

.image {
  grid-area: image;
}

.title {
  @media print {
    font-size: 1.25rem;
  }
  grid-area: title;
  margin: 0;

  font-weight: var(--font-weight-medium);

  font-size: 1.5rem;
  font-family: var(--font-mono);
}

.code {
  grid-area: code;

  font: var(--font-regular);
  font-weight: var(--font-weight-normal);
  font-size: 0.875rem;
}

.brandPrice {
  @media print {
    color: var(--text);
    font-size: 1rem;
  }
  grid-area: price;
  justify-items: end;
  order: 4;

  color: var(--grey);
}

.amount {
  grid-area: amount;
}
</style>
